import { render, staticRenderFns } from "./DocuSignTemplateAdditionalDocumentManagement.vue?vue&type=template&id=2d5e7c27&"
import script from "./DocuSignTemplateAdditionalDocumentManagement.vue?vue&type=script&lang=ts&"
export * from "./DocuSignTemplateAdditionalDocumentManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports